<template>
    <div style="text-align: left">
        <div class="list">图片库</div>
        <div class="content">
            <div class="goods">
                <div class="search">
                    图片类别：<el-cascader placeholder="商品类别" :options="options" filterable @focus="getClass"
                        @change="classificationSearch"
                        :props="{ value: 'categoryCode', label: 'categoryName', children: 'childList' }"
                        v-model="imageForm.categoryCode" class="goods-category" clearable></el-cascader>
                    &nbsp;图片名称：<el-input style="width:200px" v-model="imageForm.pictureName"></el-input>
                    <el-button type="primary" style="margin-left:10px" @click="pictureNameSearch">搜 索</el-button>
                    <el-button @click="resetSearch">重 置</el-button>
                </div>
                <br>
                <hr>
                <div style="margin-top: 20px">
                    <el-button type="primary" plain @click="openPopover">新增图片</el-button>
                    <el-button type="primary" @click="deleteImage">删除</el-button>
                    <!-- <el-button type="primary" plain>批量删除</el-button> -->
                </div>
            </div>
        </div>
        <br />
        <div class="library">
            <!-- <div v-for="(item, index) in images" :key="index" class="imgs" @click="deleteImage(item.pictureId)"> -->
            <div v-for="(item, index) in images" :key="index" class="imgs"
                :class="imgActive === item.pictureId ? 'img-active' : ''" @click="selectImg(item)">
                <!-- <img :src="item.fileUrl" :alt="item.pictureName" class="img1"> -->
                <el-image class="img1" :src="item.fileUrl" :preview-src-list="srcList[index]">
                </el-image>
                <span>{{ item.pictureName }}</span>
            </div>
        </div>
        <div class="pagination">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="imageForm.pageNum" :page-size="27"
                layout="prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <el-dialog title="添加图片" :visible.sync="dialogTableVisible" append-to-body width="30%">
            <el-form :model="addList" ref="addList" label-width="100px" class="demo-dynamic">
                <el-form-item label="商品分类" prop="categoryId" :rules="[
                    { required: true, message: '请输入商品名称', trigger: 'blur' },
                ]">
                    <el-cascader placeholder="商品分类" :options="options" filterable @focus="getClass"
                        :props="{ value: 'id', label: 'categoryName', children: 'childList' }" v-model="addList.categoryId"
                        class="goods-category"></el-cascader>
                </el-form-item>
                <el-upload class="upload-demo" :action="url + 'admin/file/upload'" accept=".png, .jpg" :limit="1" :multiple="false"
                    :before-upload="beforeUpload" :on-success="onSuccess" list-type="picture"
                    :data="{ categoryId: this.addList.categoryId }" ref="upload"
                    :headers="{ 'authorization': 'Bearer ' + this.authorization }">
                    <el-button size="small" type="primary">点击添加</el-button>
                </el-upload>
            </el-form>
            <el-button class="but" @click="dialogTableVisible = false">返回</el-button>
        </el-dialog>
    </div>
</template>

<script>
import request from '../utils/request';
import url from '../Api/imagesUrl';
export default {
    data() {
        return {
            url,
            imgActive: '',
            authorization: '',
            dialogTableVisible: false,
            addList: {
                categoryId: ''
            },
            options: [],
            imageForm: {
                categoryCode: "",
                isPage: true,
                pageNum: 1,
                pageSize: 27,
                pictureName: ""
            },
            images: [],
            num: 1,
            total: 0,
            srcList: []
        }
    },
    methods: {
        // 选中图片
        selectImg(val) {
            this.imgActive = val.pictureId
            console.log(this.imgActive);
        },
        //查询商品树
        async getClass() {
            const res = await request({
                method: "POST",
                url: "admin/category/tree",
            })
            // //console.log('res', res.data.length);
            for (let i = 0; i < res.data.length; i++) {
                // //console.log('i', i);
                for (let j = 0; j < res.data[i].childList.length; j++)
                    res.data[i].childList[j].childList = undefined
            }
            this.options = res.data
        },
        // 打开新增弹窗
        openPopover() {
            this.dialogTableVisible = true
            this.addList.categoryId = ''
        },
        // 文件上传之前
        beforeUpload() {
            if (this.addList.categoryId === '') {
                this.$message.error('请选择图片类别')
                return false
            } else {
                this.dialogTableVisible = false
            }

        },
        // 文件成功之后
        onSuccess(res) {
            this.$refs.upload.clearFiles()
            if (res.code === '200') {
                this.imageForm.pageNum = 1
                this.num = 1
                this.getImagesList()
                this.$message.success(res.message)
            } else {
                this.$message.error(res.message)
            }
        },
        // 查询图片
        async getImagesList() {
            const res = await request({
                url: 'admin/picture/getPictureList',
                method: 'POST',
                data: this.imageForm
            })
            // //console.log(res);
            this.imgActive = ''
            if (res.code === '200') {
                if (this.num === 1) {
                    this.imageSenlarge(res.data && res.data.list)
                    this.images = res.data && res.data.list
                    this.num = 2
                } else {
                    // this.$message.success(res.message)
                    this.imageSenlarge(res.data && res.data.list)
                    this.images = res.data && res.data.list

                }
                this.total = res.data && res.data.total
            } else {
                this.$message.error(res.message)
            }
        },
        // 大图预览编辑
        imageSenlarge(val) {
            let arr = []
            if (val instanceof Array) {
                val.forEach(item => {
                    arr.push([item.fileUrl])
                })
            }
            this.srcList = arr
            // console.log(this.srcList);
        },
        // 删除图片
        deleteImage() {
            if (this.imgActive === '') {
                this.$message.error("请先选择图片")
            } else {
                this.$confirm('确认删除？')
                    .then(async () => {
                        const res = await request({
                            url: `admin/picture/delPicture?pictureId=${this.imgActive}`,
                            method: 'GET',
                        })
                        //console.log(res);
                        if (res.code === '200') {
                            this.num = 1
                            this.$message.success(res.message)
                            this.imageForm.pageNum = 1
                            this.imageForm.categoryCode = ''
                            this.imageForm.pictureName = ''
                            this.getImagesList()
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(() => { });
            }

        },
        // 分页器
        handleCurrentChange() {
            this.num = 1
            this.getImagesList()
        },
        // 分类查询
        classificationSearch(val) {
            //console.log(val.length);
            // this.imageForm.pictureName = ''
            if (val.length > 0) {
                //console.log('undefined111');
                this.imageForm.categoryCode = val[1]
                this.imageForm.pageNum = 1
                this.getImagesList()
            } else {
                this.imageForm.categoryCode = ''
                this.imageForm.pageNum = 1
                this.getImagesList()
            }

        },
        //图片名称查询
        pictureNameSearch() {
            this.imageForm.pageNum = 1
            this.getImagesList()
        },
        // 重置查询
        resetSearch() {
            this.imageForm.categoryCode = ''
            this.imageForm.pictureName = ''
            this.imageForm.pageNum = 1
            this.getImagesList()
            this.imgActive = ''
        }
    },
    created() {
        this.authorization = sessionStorage.getItem('authorization')
        //console.log(this.authorization);
        this.getImagesList()
    },
    watch: {
        'addList.categoryId': {
            handler(newVal) {
                // //console.log(Array.isArray(newVal));
                if (Array.isArray(newVal)) {
                    this.addList.categoryId = newVal[1]
                }
                // 
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.list {
    background-color: #2589ff;
    color: #fff;
    text-align: center;
    width: 106px;
    height: 36px;
    margin-right: 10px;
    font-size: 16px;
    line-height: 36px;
    display: inline-block;
    border-radius: 6px;
}

.content {
    margin: 20px 0 0 0;
    background-color: #e0e0e0;
    padding: 10px;
    border-radius: 5px;
}

.goods {
    background-color: #fff;
    border-radius: 5px;
    padding: 10px 20px;
    // display: flex;
    justify-content: space-between;


    .input-with-select {
        padding: 0;
    }
}

.search {
    line-height: 40px;
}


.but {
    position: absolute;
    right: 10px;
    bottom: 25px;
}

.library {
    display: flex;
    flex-wrap: wrap;
    position: relative;

    .img-active {
        border: 1px solid #0064FE !important;
        margin: 0 10px;
    }

    .imgs {
        border: 1px solid #fff;
        position: relative;
        width: 170px;
        height: 190px;
        padding: 0 10px;
        margin: 0 10px 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;

        .img1 {
            width: 150px;
            height: 150px;
            display: block;
            margin-bottom: 20px;
        }

        .del-img {
            width: 20px;
            height: 20px;
            position: absolute;
            right: 5px;
            top: 0;
        }

        span {
            width: 170px;
        }
    }
}

.pagination {
    background-color: #fff;
    position: fixed;
    right: 25px;
    bottom: 10px;
}
</style>
